<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

import sizeVue from "@/mixins/size.vue";
import MemberAdd from "../../components/modals/MemberAdd.vue";
import MemberChangePassword from "../../components/modals/MemberChangePassword.vue";

export default {
  components: { MemberAdd, MemberChangePassword },

  data: (vm) => ({
    isLoading: false,

    options: {},
    totalItemsCount: 1000,
    itemsPerPage: 1000,

    search: null,

    isAddModal: false,
    isChangePasswordModal: false,

    selected: {},

    roles: [
      { id: "ADMIN_SUPER", name: vm.$t("ADMIN_SUPER") },
      { id: "ADMIN_VERIFIER", name: vm.$t("Admin verifier") },
      { id: "ADMIN_OBSERVER", name: vm.$t("Admin observer") },
      { id: "ACCOUNTER", name: vm.$t("Accounter") },
      { id: "ACCOUNTER_HELPER", name: vm.$t("Accounter helper") },
      { id: "QABUL_QILUVCHI", name: vm.$t("Qabul qiluvchi") },
      { id: "CONTRACTER", name: vm.$t("CONTRACTER") },
      { id: "BITRIX_OBSERVER", name: vm.$t("Bitrix observer") },
      { id: "BITRIX_MANAGER", name: vm.$t("Bitrix manager") },
    ],

    statuses: [
      { id: "ACTIVE", value: true },
      { id: "BLOCKED", value: false },
    ],

    isDeleteModal: false,

    canCreate: false,
    canUpdate: false,
    canDelete: false,
  }),

  async mounted() {
    this.canCreate = await this.hasRole("ADMIN", "CREATE");
    this.canUpdate = await this.hasRole("ADMIN", "UPDATE");
    this.canDelete = await this.hasRole("ADMIN", "DELETE");
  },

  mixins: [sizeVue],

  computed: {
    tableHeight: (vm) => vm.size.height - 280,

    ...mapGetters("admin-member", ["GET_MEMBERS"]),
    items: (vm) => vm.GET_MEMBERS,
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("admin-member", ["INIT_MEMBERS", "MEMBER_STATUS"]),

    getItems() {
      if (this.isLoading) return;
      this.isLoading = true;

      this.options.search = this.search;

      this.INIT_MEMBERS(this.options).then((totalItemsCount) => {
        this.totalItemsCount = totalItemsCount;
        this.isLoading = false;
      });
    },

    getFullName(item) {
      const lastName = item.lastName || "";
      const firstName = item.firstName || "";
      const middleName = item.middleName || "";
      return `${lastName} ${firstName} ${middleName}`;
    },

    onAddModel() {
      this.selected = {};

      this.$nextTick(() => {
        this.isAddModal = true;
      });
    },

    onEdit({ item = {} }) {
      this.selected = item;
      console.log(item)

      this.$nextTick(() => {
        this.isAddModal = true;
      });
    },

    onDelete({ item = {} }) {
      this.selected = item;

      this.$nextTick(() => {
        this.isDeleteModal = true;
      });
    },

    async confirmDelete() {
      try {
        await this.$axios.delete(`/admin/admin-member/delete/${this.selected.id}`);

        // Refresh table after delete
      } catch (e) {
        console.error(e);
      } finally {
        this.isDeleteModal = false;
        this.selected = {};
        this.getItems();
      }
    },

    cancelDelete() {
      this.isDeleteModal = false;
      this.selected = {};
    },

    onChangePasswordModal({ item = {} }) {
      this.selected = item;

      this.$nextTick(() => {
        this.isChangePasswordModal = true;
      });
    },

    onSwitch({ item = {} }) {
      if (this.isLoading) return;

      this.isLoading = false;
      this.MEMBER_STATUS(item).then(() => {
        this.isLoading = false;
        this.$nextTick(() => {
          this.getItems();
        });
      });
    },

    formatPhone(phone) {
      if (!phone) return "";
      const p = phone.replace(/^\+/, "");
      if (p.length === 12) {
        return `+${p.slice(0,3)} (${p.slice(3,5)}) ${p.slice(5,8)}-${p.slice(8,10)}-${p.slice(10)}`;
      }
      return phone;
    },

    getRoleName(id) {
      return this.roles.find((x) => x.id == id)?.name;
    },

    getStatusValue(id) {
      return this.statuses.find((x) => x.id == id)?.value;
    },

    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: { appPanel: panel, op }
        });
        return res.data === true;
      } catch {
        return false;
      }
    },
  },
};
</script>

<template>
  <v-container fluid>
    <member-add
      v-if="isAddModal"
      @close="isAddModal = false"
      @refresh="getItems"
      :data="selected"
    />

    <member-change-password
      v-if="isChangePasswordModal"
      @close="isChangePasswordModal = false"
      @refresh="getItems"
      :data="selected"
    />

    <v-card class="pa-5" flat>
      <div class="d-flex pb-5">
        <div class="title" v-text="$t('Admins')" />
        <v-spacer />
        <v-btn v-if="canCreate" fab small color="#ffcb05" class="add-btn-yellow" @click="onAddModel" elevation="0">
          <v-icon color="#00274c">mdi-plus</v-icon>
        </v-btn>
        <v-text-field
          :placeholder="$t('Izlash...')"
          append-icon="mdi-magnify"
          v-model="search"
          dense
          hide-details
          outlined
          clearable
          class="search-input ml-5"
          style="max-width: 320px;"
          @click:append="getItems"
          @keyup.enter="getItems"
          @click:clear="getItems"
        />
      </div>

      <v-data-table
        hide-default-footer
        :mobile-breakpoint="0"
        :loading="isLoading"
        :headers="[
          {
            text: '№',
            value: 'row-number',
            width: 20,
            sortable: false,
          },
          {
            text: $t('Full name'),
            value: 'fullName',
          },
          {
            text: $t('Phone'),
            value: 'phone',
            sortable: false,
          },
          {
            text: $t('Member role'),
            value: 'role_member',
          },
          {
            text: '',
            value: 'change-password',
            width: 20,
            sortable: false,
          },
          {
            text: '',
            value: 'actions',
            width: 80,
            sortable: false,
          },
          {
            text: '',
            value: 'status',
            width: 60,
            sortable: false,
          },
        ]"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItemsCount"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:body="props">
          <tbody>
            <tr :key="item.id" v-for="(item, index) in props.items">
              <td v-text="index + 1" />
              <td v-text="getFullName(item)" />
              <td v-text="formatPhone(item.phone)" />
              <td v-text="getRoleName(item.role)" />


              <td
                v-if="canUpdate"
                @click="onChangePasswordModal({ item })"
                v-ripple
                class="cursor-pointer px-2"
              >
                <v-icon :title="$t('Change password')"> mdi-lock-reset </v-icon>
              </td>
              <td v-if="canUpdate || canDelete" class="px-2">
                <div class="tc-actions">
                  <button v-if="canUpdate" class="tc-act" :title="$t('Edit')" @click="onEdit({ item })">
                    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16"><path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/></svg>
                  </button>
                  <button v-if="canDelete" class="tc-act tc-act--delete" :title="$t('Delete')" @click="onDelete({ item })">
                    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16"><path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>
                  </button>
                </div>
              </td>

              <td v-if="canUpdate" @click="onSwitch({ item })" class="pr-0">
                <v-switch
                  :loading="isLoading"
                  hide-details
                  class="mt-0"
                  v-model="item.active"
                  inset
                />
              </td>
            </tr>
            <tr v-if="!props.items.length && !isLoading">
              <td :colspan="props.headers.length + 1" class="text-center py-4">
                {{ $t("No data") }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>

    <!-- Delete confirmation dialog -->
    <v-dialog v-model="isDeleteModal" max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t('Confirm Delete') }}
        </v-card-title>
        <v-card-text>
          {{ $t('Are you sure you want to delete?') }}
          <strong>{{ selected.name }}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDelete">{{ $t('Cancel') }}</v-btn>
          <v-btn color="red" text @click="confirmDelete">{{ $t('Delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<style lang="scss" scoped>
::v-deep .search-input {
  .v-input__slot {
    background: #f1f5f9 !important;
    border-radius: 10px !important;
    min-height: 38px !important;
  }
  fieldset { border-color: transparent !important; }
  &:hover fieldset { border-color: #d0d5dd !important; }
  &.v-input--is-focused fieldset { border-color: #00274c !important; border-width: 1.5px !important; }
  .v-icon { color: #94a3b8 !important; font-size: 20px !important; }
  input { font-size: 14px; }
  input::placeholder { color: #94a3b8 !important; }
}
::v-deep .search-input.theme--dark {
  .v-input__slot { background: #22232e !important; }
  fieldset { border-color: transparent !important; }
  &:hover fieldset { border-color: #33354a !important; }
  &.v-input--is-focused fieldset { border-color: #ffd451 !important; }
  .v-icon { color: #606275 !important; }
  input { color: #d5d6de !important; }
  input::placeholder { color: #606275 !important; }
}

.full-height-table {
  //max-height: 100% !important;  /* no fixed scroll area */
  //overflow-y: visible !important;
}

.tc-actions { display: flex; gap: 6px; }
.tc-act {
  display: flex; align-items: center; justify-content: center;
  width: 34px; height: 34px; border-radius: 8px; border: 1px solid #e5e7eb;
  background: none; color: #475569; cursor: pointer; transition: all .15s;
}
.tc-act:hover { border-color: #ffd451; color: #ffd451; background: rgba(255,212,81,.06); }
.tc-act--delete:hover { border-color: #ef4444; color: #ef4444; background: rgba(239,68,68,.06); }

.theme--dark .tc-act { border-color: #2a2c3a; color: #9ca3af; }
.theme--dark .tc-act:hover { border-color: #ffd451; color: #ffd451; background: rgba(255,212,81,.06); }
.theme--dark .tc-act--delete:hover { border-color: #ef4444; color: #ef4444; background: rgba(239,68,68,.06); }
</style>